module.exports = __webpack_public_path__ + "img/KZ.76fe4022.png";